export const BANNER_ANIMATION_DURATION = 100
export const installMobileAppBannerCookie = 'install-mobile-app-banner-cookie'
